import { departmentLink, legislativeItemLink, meetingBodyLink, userLink } from './links.js';
import { legislativeItemSystemStatusValueLabels } from './value-labels.js';
export const agendaItemsCube = {
    category: 'Legislation',
    description: 'Agenda items linked to meetings, departments, and legislative items.',
    label: 'Agenda Items',
    question: 'What is on the agenda for each meeting?',
    bestFor: 'The line-by-line agenda — every item with its number, type, sponsoring department, and special flags like consent, emergency, or public hearing.',
    tags: ['Agenda', 'Items', 'Departments'],
    requiredModule: 'hasAgenda',
    measures: {
        'agenda_items.count': { label: 'Count', type: 'number' },
    },
    dimensions: {
        'agenda_items.item_number': { label: 'Item Number', type: 'string' },
        'departments.name': { label: 'Department', link: departmentLink, type: 'string' },
        'legislative_items.code': { label: 'Number', link: legislativeItemLink, type: 'string' },
        'legislative_items.full_title': { label: 'Title', link: legislativeItemLink, type: 'string' },
        'legislative_items.requesting_consent': { label: 'Consent Agenda', type: 'boolean' },
        'legislative_items.requesting_emergency': { label: 'Emergency Request', type: 'boolean' },
        'legislative_items.executive_session': { label: 'Executive Session', type: 'boolean' },
        'legislative_items.public_hearing': { label: 'Public Hearing', type: 'boolean' },
        'legislative_items.short_title': {
            label: 'Short Title',
            link: legislativeItemLink,
            type: 'string',
        },
        'legislative_items.status': {
            label: 'System Status',
            type: 'string',
            valueLabels: legislativeItemSystemStatusValueLabels,
        },
        'legislative_items.summary': { label: 'Summary', narrative: true, type: 'string' },
        'legislative_statuses.name': { label: 'Public Meeting Status', type: 'string' },
        'legislative_types.name': { label: 'Item Type', type: 'string' },
        'meeting_bodies.name': { label: 'Meeting Body', link: meetingBodyLink, type: 'string' },
        'users.display_name': { label: 'Staff Contact', link: userLink, type: 'string' },
    },
    timeDimensions: {
        'legislative_items.target_meeting_date': { label: 'Target Meeting Date', type: 'date' },
    },
};
